import AllTours from "@/data/AllTours";
import actions from "@/store/actions";
import services from "./index";
import utils from "@/utils";
import api from "@/api";
import { socketDisableTour } from "../../socket";

export const startCertificateTour = () => {
  return (dispatch) => {
    utils.addToLocalStorage("certificate-tour", "YES");
    dispatch(actions.tourActions.startcertificatetour());
  };
};
export const stopCertificateTour = () => {
  return (dispatch) => {
    utils.addToLocalStorage("certificate-tour", "NO");
    dispatch(actions.tourActions.stopcertificatetour());
  };
};
export const startPostEnrollTour = () => {
  return async (dispatch) => {
    utils.addToLocalStorage("post-enroll-tour", "YES");
    dispatch(actions.tourActions.startpostenrolltour());
  };
};
export const stopPostEnrollTour = () => {
  return async (dispatch) => {
    utils.removeFromLocalStorage("post-enroll-tour");
    dispatch(actions.tourActions.stoppostenrolltour());
  };
};
export const startPreEnrollTour = () => {
  return async (dispatch) => {
    utils.addToLocalStorage("pre-enroll-tour", "YES");
    dispatch(actions.tourActions.startpreenrolltour());
  };
};
export const stopPreEnrollTour = () => {
  return async (dispatch) => {
    utils.addToLocalStorage("pre-enroll-tour", "NO");
    dispatch(actions.tourActions.stoppreenrolltour());
  };
};
export const startNotesTour = () => {
  return async (dispatch) => {
    utils.addToLocalStorage("notes-tour", "YES");
    dispatch(actions.tourActions.startnotestour());
  };
};
export const stopNotesTour = () => {
  return async (dispatch) => {
    utils.removeFromLocalStorage("notes-tour");
    dispatch(actions.tourActions.stopnotestour());
  };
};

export const startNewVideoPageTour = () => {
  return async (dispatch) => {
    dispatch(actions.tourActions.startvideopagetour());
  };
};

export const startResumeBuilderTour = () => {
  return async (dispatch) => {
    dispatch(actions.tourActions.startresumebuildertour());
  };
};

export const startProfileTour = () => {
  return async (dispatch) => {
    dispatch(actions.tourActions.startprofiletour());
  };
};

export const disableTour = (userId, tourKey, socket) => {
  return async (dispatch) => {
    const stopActions = {
      profilePageTour: actions.tourActions.stopprofiletour,
      videoPageTour: actions.tourActions.stopvideopagetour,
      resumeBuilderTour: actions.tourActions.stopresumebuildertour,
    };

    const stopAction = stopActions[tourKey];
    try {
      if (stopAction) dispatch(stopAction());
      socketDisableTour({ userId, tourId: AllTours[tourKey] }, socket);
    } catch (error) {
      console.error("Error disabling tour:", error);
    }
  };
};
